<div #examenesListContainer class="examenes-list-container">
  <header>
    <div class="title-group">
      <h1>Exámenes</h1>
      <app-cinturon-graphics
        [graduacion]="getGraduacionForDisplay()" 
        [isLoading]="isLoading"
        size="medium">
      </app-cinturon-graphics>
    </div>
    <div (click)="addExamen()" class="new-button" title="Agregar examen" aria-label="Add Exam">
      <i class="fas fa-plus"></i> Nuevo
    </div>
  </header>
  
  <div *ngIf="examenes.length > 0" class="examenes-results">
    <div *ngIf="errorMessage" class="error-message">{{ errorMessage }}</div>
    <div *ngFor="let examen of examenes" class="examen-card">
      <div class="examen-card-content">
        <div>
          <label>Graduación:</label>
          <!-- Show select when in edit mode - use availableGraduaciones (no BLANCO) -->
          <select *ngIf="examen.isEditMode" 
                  [(ngModel)]="examen.idGraduacion"
                  (change)="onGraduacionChange(examen)">
            <option *ngFor="let graduacion of availableGraduaciones" [value]="graduacion.id">{{ graduacion.nombre }}</option>
          </select>
          <!-- Show readonly text when not in edit mode -->
          <div *ngIf="!examen.isEditMode" class="readonly-graduacion">
            {{ getGraduacionDescripcion(examen.idGraduacion) }}
          </div>
          
          <!-- Belt skipping warning - minimal styling -->
          <div *ngIf="getBeltSkippingWarning(examen)" 
               style="font-size: 11px; color: #d68910; margin-top: 2px; font-style: italic;">
            ⚠️ {{ getBeltSkippingWarning(examen) }}
          </div>
        </div>
        <div>
          <label>Fecha:</label>
          <input [(ngModel)]="examen.fcExamen" [readonly]="!examen.isEditMode" type="date"
                 (keydown.enter)="$event.preventDefault(); saveChanges(examen)" 
                 [class.new-exam-date]="examen.id === 0 && examen.isEditMode" />
        </div>
      </div>
      <div class="buttons-container">
        <button *ngIf="!examen.isEditMode" 
                (click)="toggleEditMode(examen)" 
                class="icon-button edit-btn" 
                title="Editar">
          <i class="fas fa-pencil-alt"></i>
        </button>
        <button *ngIf="examen.isEditMode" 
                class="icon-button cancel-btn" 
                (click)="toggleEditMode(examen)" 
                title="Cancelar">
          <i class="fas fa-times"></i>
        </button>
        <button type="button" 
                [disabled]="!examen.isEditMode" 
                (click)="saveChanges(examen, $event)" 
                class="icon-button save-btn"
                title="Guardar">
          <i class="fas fa-save"></i>
        </button>
      </div>
    </div>
  </div>
</div>